import React from 'react';

const SvgPay2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="17"
    viewBox="0 0 10 17"
    fill="none"
    {...props}
  >
    <path
      d="M7.03734 7.55352L3.66234 6.56602C3.27171 6.45352 2.99984 6.08789 2.99984 5.68164C2.99984 5.17227 3.41234 4.75977 3.92171 4.75977H5.99359C6.37484 4.75977 6.74984 4.87539 7.06234 5.08789C7.25296 5.21602 7.50921 5.18477 7.67171 5.02539L8.75921 3.96289C8.98109 3.74727 8.94984 3.38789 8.70296 3.19727C7.93734 2.59727 6.98109 2.26289 5.99984 2.25977V0.759766C5.99984 0.484766 5.77484 0.259766 5.49984 0.259766H4.49984C4.22484 0.259766 3.99984 0.484766 3.99984 0.759766V2.25977H3.92171C1.93109 2.25977 0.331088 3.96914 0.515463 5.99727C0.646713 7.43789 1.74671 8.60977 3.13421 9.01602L6.33734 9.95352C6.72796 10.0691 6.99984 10.4316 6.99984 10.8379C6.99984 11.3473 6.58734 11.7598 6.07796 11.7598H4.00609C3.62484 11.7598 3.24984 11.6441 2.93734 11.4316C2.74671 11.3035 2.49046 11.3348 2.32796 11.4941L1.24046 12.5566C1.01859 12.7723 1.04984 13.1316 1.29671 13.3223C2.06234 13.9223 3.01859 14.2566 3.99984 14.2598V15.7598C3.99984 16.0348 4.22484 16.2598 4.49984 16.2598H5.49984C5.77484 16.2598 5.99984 16.0348 5.99984 15.7598V14.2535C7.45609 14.2254 8.82171 13.3598 9.30296 11.9816C9.97484 10.0566 8.84671 8.08164 7.03734 7.55352Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPay2;
